module.exports = __webpack_public_path__ + "img/2-4.0b1a57bc.svg";